import request from './http'

//获取问题分类
export function getQuestionType(data) {
    return request({
      url: `marketall/ticket/getQuestionType`,
      method: 'post',
      data
    })
  }

  //提交工单
export function getSubmitTicket(data) {
    return request({
      url: `marketall/ticket/submitTicket`,
      method: 'post',
      data
    })
  }

  //工单继续提交
export function getResubmitTicket(data) {
    return request({
      url: `marketall/ticket/resubmitTicket`,
      method: 'post',
      data
    })
  }

//撤回工单
export function getRetractTicket(data) {
    return request({
      url: `marketall/ticket/retractTicket`,
      method: 'post',
      data
    })
  }

  //个人工单列表
export function getPrivateTicket(data) {
    return request({
      url: `marketall/ticket/getPrivateTicket`,
      method: 'post',
      data
    })
  }


//工单详情
export function getTicketDetails(data) {
    return request({
      url: `marketall/ticket/getTicketDetails`,
      method: 'post',
      data
    })
  }

//提交工单审核
export function getSubmitAuditTicket(data) {
    return request({
      url: `marketall/ticket/submitAuditTicket`,
      method: 'post',
      data
    })
  }

  //个人未读工单数
export function getUnreadCount(data) {
    return request({
      url: `marketall/ticket/getUnreadCount`,
      method: 'post',
      data
    })
  }
//后台工单列表
export function getTicketList(data) {
    return request({
      url: `marketall/ticket/getTicketList`,
      method: 'post',
      data
    })
  }


  //每日工单数
export function getDailyCount(data) {
    return request({
      url: `marketall/ticket/getDailyCount`,
      method: 'post',
      data
    })
  }

    //审核工单
export function getAuditTicket(data) {
    return request({
      url: `marketall/ticket/auditTicket`,
      method: 'post',
      data
    })
  }

//文件下载
export function getDownloadFile(data) {
    return request({
      url: `marketall/ticket/downloadFile`,
      method: 'post',
      data
    })
  }
  //回复工单
export function getResponTicket(data) {
    return request({
      url: `marketall/ticket/responTicket`,
      method: 'post',
      data
    })
  }

    //个人中心 个人中心 已回复未读工单更改状态
export function getReadTicket(data) {
    return request({
      url: `marketall/ticket/readTicket`,
      method: 'post',
      data
    })
  }

//结束工单
export function getEndTicket(data) {
  return request({
    url: `marketall/ticket/endTicket`,
    method: 'post',
    data
  })
}


   //查询用户当前账户余额
   export function GetUserAccount(data) {
    return request({
      url: `/order/transfer/getUserAccount`,
      method: 'post',
      data
    })
  }

